import { useCallback, useEffect, useRef, useState } from 'react';
/** 验证码发送冷却秒数，与后端约定保持一致。 */
const CAPTCHA_COUNTDOWN_SECONDS = 60;
/** 验证码发送倒计时 Hook，冷却期间按钮禁用并展示剩余秒数。 */
export function useCaptchaCountdown() {
    /** 剩余冷却秒数，0 表示可发送。 */
    const [countdown, setCountdown] = useState(0);
    /** 倒计时定时器引用，用于卸载和重发时清理。 */
    const timerRef = useRef(null);
    /** 停止正在进行的倒计时。 */
    const stopTimer = useCallback(() => {
        if (timerRef.current !== null) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    useEffect(() => stopTimer, [stopTimer]);
    /** 开始一轮 60 秒冷却倒计时。 */
    const startCountdown = useCallback(() => {
        stopTimer();
        setCountdown(CAPTCHA_COUNTDOWN_SECONDS);
        timerRef.current = setInterval(() => {
            setCountdown((seconds) => {
                if (seconds <= 1) {
                    stopTimer();
                    return 0;
                }
                return seconds - 1;
            });
        }, 1000);
    }, [stopTimer]);
    return { countdown, startCountdown };
}
